import { jsx as _jsx } from "react/jsx-runtime";
import GenericSettingsPage from './GenericSettingsPage';
const CompetitorsPage = () => {
    const columns = [
        { key: 'name', label: 'Competitor Name', type: 'text', required: true },
        { key: 'short_code', label: 'Short Code', type: 'text', width: 'w-24' },
        { key: 'description', label: 'Description', type: 'text' },
        { key: 'sort_order', label: 'Sort Order', type: 'number', min: 0, width: 'w-24' },
    ];
    return (_jsx(GenericSettingsPage, { tableName: "competitors", title: "Competitors", columns: columns, apiPath: "competitors" }));
};
export default CompetitorsPage;
